module.exports = __webpack_public_path__ + "img/value-icon.aa0d7b12.svg";